import { createFormHookContexts, createFormHook } from '@tanstack/react-form';
import { TextField } from './fields/text';
import { NumberField } from './fields/number';
import { MoneyField } from './fields/money';
import { FormDebugger } from './fields/debugger';
import { RadioField } from './fields/radio';
import { DateField } from './fields/date';
import { SwitchField } from './fields/switch';
import { ToggleGroupField } from './fields/toggle-group';
import { LicensePlateField } from './fields/license-plate';
import { RadioSwitchField } from './fields/radio-switch';
import { TextareaField } from './fields/textarea';
import { UploadAttachments } from './fields/upload-attachments';
import { RichtTextEditorField } from './fields/richt-text-editor';
import { SelectField } from './fields/select';
import { PostcodeLookup } from './fields/postcode-lookup';
import { StatementCheckboxField } from './fields/statement-checkbox';

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextareaField,
    TextField,
    NumberField,
    MoneyField,
    RadioField,
    DateField,
    SwitchField,
    ToggleGroupField,
    LicensePlateField,
    RadioSwitchField,
    UploadAttachments,
    RichtTextEditorField,
    SelectField,
    PostcodeLookup,
    StatementCheckboxField
  },
  formComponents: {
    FormDebugger,
  },
});
